import React from 'react'
import { Parser } from '../../common'

const List = ({ block }) => {
    return (
        <ul className="!baseocom-ml-5 !baseocom-pl-0">
            <Parser content_block={block?.childrens} />
        </ul>
    )
}

export default List
